import { Component, OnInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { UserScholarshipReport } from '../../../../models';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store';

@Component({
  selector: 'app-scholership-report',
  templateUrl: './scholership-report.component.html',
  styleUrls: ['./scholership-report.component.css']
})
export class ScholershipReportComponent extends ReportBase implements OnInit {
  
  report: UserScholarshipReport;

  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'dateAdded', type: 'date', title: 'Date' },
    { name: 'feeName', type: 'text', title: 'Group/Team' },
    { name: 'gender', type: 'select', title: 'Gender', options: [{ text: 'Male', value: 'M' }, { text: 'Female', value: 'F' }] },
    { name: 'scholarshipBy', type: 'text', title: 'Scholarship By' },
    { name: 'scholarshipType', type: 'text', title: 'Scholarship Type' },
    { name: 'amount', type: 'number', title: 'Amount' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {    
    this.pullData('getScholarshipReportData');
  }

  searchReport(value) {
    console.log('search value:', value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/scholership-report/scholership-report.component.ts